<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加模板"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="660px"
  >
    <div class="dialog__container">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        inline
      >
        <div>
          <el-form-item label="模板名称：" prop="templateName" class="input-with-col2 mr0">
            <el-input
              clearable
              :disabled="!canEditClientName"
              placeholder="请输入模板名称："
              size="mini"
              v-model="form.templateName"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark" class="input-with-col2 mr0">
            <el-input
              clearable
              :disabled="!canEditClientName"
              placeholder="请输入备注："
              size="mini"
              v-model="form.remark"
            ></el-input>
          </el-form-item>
          
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { saveData } from "@/api/salesManagement/whmb.js";
export default {
  props: {
    clientForm: {
      type: Object,
      required: false,
      default: () => ({
        templateName: "",
        remark: "",
        id: "",
      }),
    },
  },
  data() {
    return {
      propertyObj: null,
      canEditClientName: true,
      unitList: [],
      form: {
        remark: "",
        templateName: "",
        id: "",
      },

      loading: false,
      rules: {
        remrak: [
          {
            required: false,
            message: "请输入备注",
            trigger: "blur",
          },
        ],
        templateName: [
          {
            required: true,
            message: "模板名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    if (this.clientForm && this.clientForm.id) {
      // 说明是添加客户联系人的
      this.form.remark = this.clientForm.remark;
      this.form.templateName = this.clientForm.templateName;
      this.form.id = this.clientForm.id;
      this.canEditClientName = true;
    } else {
      this.canEditClientName = true;
    }
   
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },

    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        console.log(this.form);
        const res = await saveData(this.form);
        this.loading = false;
        if (res.code === 200) {
          if (this.clientForm && this.clientForm.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("添加成功");
          }
          this.$emit('confirm')
        }
      });
    },
  },
};
</script>

<style lang="scss">
.add-contacts-text-btn {
  margin-left: 10px;
}
.delete-btn {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesManagement/whmb/components/AddUser.vue